import { z } from "zod";

export enum Environment {
	development = "development",
	staging = "staging",
	production = "production",
}

export const envVarsSchema = z.object({
	VITE_APP_VERSION: z.string().min(1),
	VITE_API_URL: z.string().min(1),
	VITE_WEB_APP_URL: z.string().min(1),
	VITE_APP_ENV: z.nativeEnum(Environment).default(Environment.development),
	VITE_MAPS_API_KEY: z.string().min(1),
	VITE_CLARITY_PROJECT_ID: z.string().min(1),
});

export const envVars = envVarsSchema.parse(import.meta.env);
